// BUILD COLORS INNER
function buildColors(format_build_options, formated_teflon_options) {
  let build_colors = "";

  if (formated_teflon_options != null && formated_teflon_options.length > 1) {
    build_colors = `
      <div class="swatch-wrapper">
        <label class="grn-txt small mb-5 d-block">Standard Cloth</label>
        ${format_build_options}
      </div>
      <div class="swatch-wrapper">
        <label class="grn-txt small mb-5 d-block">Teflon Cloth</label>
        ${formated_teflon_options}
      </div>
    `;
  } else {
    build_colors = format_build_options;
  }

  return build_colors;
}

// ACTION ON SELECT CHANGE
function selectChangeHandler(selectEl) {
  if (!selectEl) return;

  if (selectEl.dataset.productOption === "Pocket Style") {
    const images = document.querySelectorAll(".pocket-style-image");
    images.forEach((i) => {
      i.style.display = "none";
      if (i.dataset.productOptionValue === selectEl.value) {
        i.style.display = "block";
      }
    });
  }

  const selectedOption = selectEl.querySelector(`option[value="${selectEl.value}"]`);
  const price = selectedOption ? selectedOption.dataset.addonPrice || "0" : "0";
  selectEl.dataset.currentOptionPrice = price;

  updateFinalPrice();
}

// ADD EVENT LISTENER TO SELECTS
function setSelectChangeHandlers() {
  const addonSelects = document.querySelectorAll(
    "#custom_addon_variations .options-selection__input-select.custom-var-select"
  );

  addonSelects.forEach(function (selectElement) {
    selectElement.addEventListener("change", function (e) {
      selectChangeHandler(e.target);
    });
  });
}

// PDP UPDATE FINAL PRICE
function updateFinalPrice() {
  let final_price_total = 0;
  let selects_total = 0;

  const variantPriceEl = document.getElementById("variant-price");
  const print_final_price = document.getElementById("add-ons-price");
  const the_product_price_container = document.querySelector(
    ".product-pricing .product__price .price__current .money"
  );

  if (!variantPriceEl || !print_final_price || !the_product_price_container) {
    return;
  }

  const the_product_price = variantPriceEl.innerHTML
    .replace(/\s/g, "")
    .replace("$", "")
    .replace(",", "");

  const format_the_product_price = Number(the_product_price) || 0;

  const all_selects = document.querySelectorAll(
    "#custom_addon_variations .options-selection__input-select"
  );

  all_selects.forEach(function (single_select) {
    const current_option_price = Number(single_select.dataset.currentOptionPrice || 0);
    selects_total += current_option_price;
  });

  final_price_total = selects_total;

  const formatted_final_price = final_price_total.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });

  print_final_price.innerHTML = formatted_final_price;

  const the_product_price_w_adds = format_the_product_price + final_price_total;
  const formatted_product_price_w_adds = the_product_price_w_adds.toLocaleString(
    "en-US",
    { style: "currency", currency: "USD" }
  );

  the_product_price_container.innerHTML = formatted_product_price_w_adds;
}

function embroideryChanger() {
  const embroideryRoot = document.getElementById("embroidery-options");
  const embroideryColorSelect = document.getElementById("pool-tables-embroidery-color");
  const embroideryFontSelect = document.getElementById("embroidery-font");
  const embroideryTextInput = document.getElementById("embroidery-text");

  if (!embroideryRoot || !embroideryColorSelect || !embroideryFontSelect || !embroideryTextInput) {
    return;
  }

  if (window.__embroideryChangerInitialized) return;
  window.__embroideryChangerInitialized = true;

  const embroideryTrigger = document.querySelector(
    'label.view-option[data-id="pool-tables-embroidery-color"]'
  );

  const embroideryTextInputs = document.querySelectorAll(".embroidery-text");

  const colorPriceMap = {};
  embroideryColorSelect.querySelectorAll("option").forEach((option) => {
    colorPriceMap[option.value] = option.dataset.addonPrice || "0";
  });

  let isInternalColorUpdate = false;

  function getColorSwatches() {
    return document.querySelectorAll(".swatch-select-choice-inner[data-embroidery-color]");
  }

  function getFontSwatches() {
    return document.querySelectorAll(".image-swatch-image-container[data-embroidery-font]");
  }

  function syncTextUI(value) {
    embroideryTextInputs.forEach((input) => {
      if (input.value !== value) input.value = value;
    });
  }

  function syncColorUI(selectedColor) {
    const isActive = selectedColor !== "No Thanks";
    embroideryRoot.classList.toggle("active", isActive);

    getColorSwatches().forEach((swatch) => {
      const choice = swatch.closest(".swatch-select-choice");
      if (!choice) return;

      choice.classList.toggle(
        "active",
        swatch.dataset.embroideryColor === selectedColor
      );
    });

    if (!isActive) {
      embroideryFontSelect.value = "None";
      syncFontUI("None");
      syncTextUI("");
    }
  }

  function syncFontUI(selectedFont) {
    getFontSwatches().forEach((font) => {
      const choice = font.closest(".image-swatch-select-choice");
      if (!choice) return;

      choice.classList.toggle(
        "active",
        font.dataset.embroideryFont === selectedFont
      );
    });
  }

  function setEmbroideryColor(selectedColor, userInitiated = false) {
    if (!selectedColor) return;

    isInternalColorUpdate = !userInitiated;
    embroideryColorSelect.value = selectedColor;
    embroideryColorSelect.dataset.currentOptionPrice = colorPriceMap[selectedColor] || "0";
    embroideryColorSelect.dispatchEvent(new Event("change", { bubbles: true }));
    syncColorUI(selectedColor);
    updateFinalPrice();
    isInternalColorUpdate = false;
  }

  function setEmbroideryFont(selectedFont) {
    if (!selectedFont) return;

    embroideryFontSelect.value = selectedFont;
    embroideryFontSelect.dispatchEvent(new Event("change", { bubbles: true }));
    syncFontUI(selectedFont);
  }

  embroideryColorSelect.addEventListener("change", function (e) {
    const selectedColor = embroideryColorSelect.value;
    embroideryColorSelect.dataset.currentOptionPrice =
      colorPriceMap[selectedColor] || "0";

    syncColorUI(selectedColor);
    updateFinalPrice();

    if (
      !isInternalColorUpdate &&
      e.isTrusted &&
      selectedColor !== "No Thanks" &&
      embroideryTrigger
    ) {
      embroideryTrigger.click();
    }
  });

  embroideryFontSelect.addEventListener("change", function () {
    syncFontUI(embroideryFontSelect.value);
  });

  embroideryTextInputs.forEach((input) => {
    input.addEventListener("input", function (e) {
      syncTextUI(e.target.value);
    });
  });

  document.addEventListener(
    "pointerdown",
    function (e) {
      const colorSwatch = e.target.closest(
        ".swatch-select-choice-inner[data-embroidery-color]"
      );

      if (colorSwatch) {
        e.preventDefault();
        const selectedColor = colorSwatch.dataset.embroideryColor;
        setEmbroideryColor(selectedColor, false);
        return;
      }

      const fontSwatch = e.target.closest(
        ".image-swatch-image-container[data-embroidery-font]"
      );

      if (fontSwatch) {
        e.preventDefault();
        const selectedFont = fontSwatch.dataset.embroideryFont;
        setEmbroideryFont(selectedFont);
      }
    },
    true
  );

  const observer = new MutationObserver(() => {
    syncColorUI(embroideryColorSelect.value);
    syncFontUI(embroideryFontSelect.value);
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  syncColorUI(embroideryColorSelect.value);
  syncFontUI(embroideryFontSelect.value);
  syncTextUI(embroideryTextInput.value);
}

// CONTROLS POCKET SELECTION
function pocketChanger() {
  const pocketOptions = document.querySelectorAll(".pocket-choice");
  const pocketSelect = document.querySelector(
    ".custom-var-select[data-option-label='Pocket Style']"
  );
  const selectedPocketImg = document.querySelector(".selected-pocket-image img");

  if (!pocketSelect || !pocketOptions.length) {
    return;
  }

  const pocketSelectOptions = pocketSelect.querySelectorAll("option");
  const pocketChoice = pocketSelect.value;

  if (pocketChoice) {
    const activeOption = document.querySelector(
      ".image-swatch-select-choice[data-value='" + pocketChoice + "']"
    );

    if (activeOption) {
      activeOption.classList.add("active");

      const activeImg = activeOption.querySelector("img");
      if (activeImg && selectedPocketImg) {
        const pocketImgSrc = activeImg.getAttribute("src");
        if (pocketImgSrc) {
          selectedPocketImg.setAttribute("src", pocketImgSrc);
        }
      }
    }
  }

  const availableOptions = [];
  pocketSelectOptions.forEach((pocketSelectOption) => {
    availableOptions.push(pocketSelectOption.value);
  });

  pocketOptions.forEach((pocketOption) => {
    if (!availableOptions.includes(pocketOption.getAttribute("data-value"))) {
      pocketOption.style.display = "none";
    }

    pocketOption.addEventListener("click", function () {
      pocketOptions.forEach((option) => {
        option.classList.remove("active");
      });

      const newPocketChoice = pocketOption.getAttribute("data-value");
      const newPocketImg = pocketOption.querySelector("img");

      if (!newPocketChoice) return;

      pocketOption.classList.add("active");
      pocketSelect.value = newPocketChoice;
      selectChangeHandler(pocketSelect);

      if (newPocketImg && selectedPocketImg) {
        const newPocketImgSrc = newPocketImg.getAttribute("src");
        if (newPocketImgSrc) {
          selectedPocketImg.setAttribute("src", newPocketImgSrc);
        }
      }
    });
  });
}

// CONTROLS ENGRAVING
function engravingChanger() {
  const engraving = document.getElementById("engraving");
  const engraving_options = document.getElementById("engraving-options");
  const engraving_text = document.getElementById("engraving-text");

  if (!engraving || !engraving_options || !engraving_text) {
    return;
  }

  engraving.addEventListener("change", function () {
    const current_engraving_value = engraving.value;

    if (current_engraving_value !== "No Engraving") {
      engraving_options.classList.add("active");
    } else {
      engraving_options.classList.remove("active");
      engraving_text.value = "";
    }
  });
}

// CONTROLS ACCESSORY KITS
function kitChanger() {
  const allKits = document.querySelectorAll("input[name='accessory-option']");
  const kitSelect = document.querySelector("#pool-tables-accessory-kit");

  if (!kitSelect || !allKits.length) {
    return;
  }

  const kitSelectOptions = document.querySelectorAll(
    "#pool-tables-accessory-kit option"
  );

  kitSelect.addEventListener("change", function () {
    const current_kit = kitSelect.value;

    allKits.forEach((single_kit) => {
      const this_kit = single_kit.value;
      if (this_kit === current_kit) {
        single_kit.parentNode.classList.add("active");
        single_kit.checked = true;
      } else {
        single_kit.parentNode.classList.remove("active");
        single_kit.checked = false;
      }
    });
  });

  allKits.forEach((single_kit) => {
    single_kit.addEventListener("click", function () {
      const this_kit = single_kit.value;
      single_kit.parentNode.classList.add("active");
      kitSelect.value = this_kit;

      kitSelectOptions.forEach((single_kit_option) => {
        if (single_kit_option.value === this_kit) {
          kitSelect.dataset.currentOptionPrice =
            single_kit_option.dataset.addonPrice || "0";
          updateFinalPrice();
        }
      });
    });
  });
}

// UPDATED FELT SELECT ON SIZE AND FELT SELECT
function updateFormFeltSelect(size = null) {
  const formFeltSelect = document.getElementById("pool-table-felt-selection");
  const formSizeSelect = document.querySelector('select[data-product-option="Size"]');
  const flyoutFeltOptions = document.querySelectorAll(".color-swatch-option");
  const selectedFlyoutFeltOption = document.querySelector(".color-swatch-option:checked");

  if (!formFeltSelect || !selectedFlyoutFeltOption) {
    return;
  }

  const selectedFlyoutFeltOptionColor = selectedFlyoutFeltOption.getAttribute(
    "data-swatch-color-name"
  );

  let selectedSizeOption;
  if (formSizeSelect) selectedSizeOption = formSizeSelect.value;
  else selectedSizeOption = size;

  flyoutFeltOptions.forEach(function (option) {
    option.selected = false;
  });

  const newFeltSelection = document.querySelector(
    `.color-swatch-option[data-swatch-color-name="${selectedFlyoutFeltOptionColor}"][data-size="${selectedSizeOption}"]`
  );

  if (!newFeltSelection) {
    return;
  }

  newFeltSelection.selected = true;

  const swatchVariantId = newFeltSelection.getAttribute("data-variant-id");

  const matchingOption = document.querySelector(
    `#pool-table-felt-selection option[data-variant-id="${swatchVariantId}"]`
  );

  if (matchingOption) {
    formFeltSelect.value = matchingOption.value;
    formFeltSelect.dispatchEvent(new Event("change"));
    updateFinalPrice();
  } else {
    console.log("No matching option found for swatchVariantId:", swatchVariantId);
  }
}

function updateDiningTopOptions(selectedSize) {
  if (!selectedSize) return;

  let selectedSizeNumber = selectedSize.split(" ")[0];
  selectedSizeNumber = selectedSizeNumber.replace("ft", "");

  const diningTopSelect = document.querySelector(
    'select[data-option-label="Matching Dining Top"]'
  );

  if (diningTopSelect) {
    const diningtopValue = diningTopSelect.value;
    const diningTopOptions = document.querySelectorAll(
      'select[data-option-label="Matching Dining Top"] option'
    );

    diningTopOptions.forEach((option) => {
      if (option.value.includes(selectedSizeNumber) || option.value === "No Thanks") {
        option.style.display = "block";

        if (diningtopValue !== "No Thanks") {
          option.selected = true;
          diningTopSelect.value = option.value;
        }
      } else {
        option.style.display = "none";
      }
    });
  }
}

// CONTROLS TABLE SIZE SELECTION
function sizeChanger() {
  const flyoutSizeRadios = document.querySelectorAll("input[name='option-size']");
  const sizeSelect = document.querySelector("select[data-product-option='Size']");
  const tableSizeSelect = document.querySelector(
    "select[data-product-option='Table Size']"
  );
  const sizeSelectImage = document.querySelector("#size-flyout-image");
  const sizeSelectChoiceLabel = document.querySelector(
    "#Size[data-product-option='Size'] .choice"
  );

  let selectedSize = null;

  if (sizeSelect) selectedSize = sizeSelect.value;
  if (tableSizeSelect) selectedSize = tableSizeSelect.value;

  if (sizeSelect) {
    const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
    const selectedShipBy = selectedOption
      ? selectedOption.getAttribute("data-addon-ships") || ""
      : "";

    if (sizeSelectChoiceLabel) {
      if (selectedShipBy !== "") {
        sizeSelectChoiceLabel.innerHTML = `${selectedSize} - ${selectedShipBy}`.trim();
      } else {
        sizeSelectChoiceLabel.innerHTML = selectedSize;
      }
    }

    updateDiningTopOptions(selectedSize);
  }

  flyoutSizeRadios.forEach((sizeInput) => {
    sizeInput.addEventListener("click", function (e) {
      const selectedSize = e.target.value;
      const selectedShipBy = e.target.dataset.addonShips;
      const selectedImageUrl = e.target.dataset.imageUrl;

      if (selectedImageUrl && sizeSelectImage) {
        sizeSelectImage.src = selectedImageUrl;
      }

      if (sizeSelectChoiceLabel) {
        if (selectedShipBy !== "") {
          sizeSelectChoiceLabel.innerHTML = selectedSize + " - " + selectedShipBy;
        } else {
          sizeSelectChoiceLabel.innerHTML = selectedSize;
        }
      }

      if (sizeSelect && sizeSelect.length) {
        updateSizeSelection(sizeSelect, selectedSize);
      }

      if (tableSizeSelect && tableSizeSelect.length) {
        updateSizeSelection(tableSizeSelect, selectedSize);
      }

      updateFormFeltSelect();
      updateDiningTopOptions(selectedSize);
      clearOldSizeSelection(sizeInput);
    });
  });

  function updateSizeSelection(selectElement, selectedSize) {
    if (!selectElement) return;

    selectElement.value = selectedSize;
    selectElement.dispatchEvent(new Event("change"));

    const selectedOption = selectElement.querySelector(
      `option[value='${selectedSize}']`
    );

    if (selectedOption) {
      selectElement.dataset.currentOptionPrice =
        selectedOption.dataset.addonPrice || "0";
      updateFinalPrice();
    }
  }

  function clearOldSizeSelection(currentSizeInput) {
    flyoutSizeRadios.forEach((sizeInput) => {
      if (sizeInput !== currentSizeInput) {
        sizeInput.parentNode.classList.remove("active");
      }
    });
  }
}

// CONTROLS NEW FELT SELECTION
function feltChanger() {
  const color_swatches = document.querySelectorAll(".color-swatch-option");
  const color_name_containers = document.querySelectorAll(".color-name");
  const color_price_containers = document.querySelectorAll(".color-price");

  const init_swatch = document.querySelector(".color-swatch-option:checked");
  let init_color = null;
  if (init_swatch) init_color = init_swatch.dataset.swatchColor;

  setColor(init_color);

  color_swatches.forEach(function (swatch) {
    swatch.addEventListener("click", function (e) {
      const color = e.target.dataset.swatchColor;
      const color_name = e.target.dataset.swatchColorName;
      const color_price = e.target.dataset.swatchColorPrice;
      const size = e.target.dataset.size;

      color_name_containers.forEach((container) => {
        container.innerHTML = color_name;
      });

      color_price_containers.forEach((container) => {
        container.innerHTML = color_price !== "$0.00" ? " (+" + color_price + ")" : "";
      });

      setColor(color);
      updateFormFeltSelect(size);
    });
  });

  function setColor(color) {
    const feltSelectionElement = document.querySelector("[data-id='felt_selection' i]");
    if (feltSelectionElement) {
      feltSelectionElement.setAttribute("data-selected-color", color);
    }

    const changeElements = document.querySelectorAll(
      ".atc--product-image img, .pool-table-bg-change img, #pool-table-content .dimension-block img, #pool-table-content .image-section img, #pool-table-content #pooltable-main-image > a > img"
    );

    changeElements.forEach(function (el) {
      el.style.backgroundColor = color;
    });
  }
}

// DYNAMIC DEFAULT ADDON OPTION SELECTOR
class FlyoutOption extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const imageSwatchContainer = this.querySelector(".image-swatch-select-container");
    const selectedOptionImg = this.querySelector(".selected-option-image img");
    const optionSelect = document.querySelector(
      `select[id='${this.getAttribute("data-id")}']`
    );

    const updateImage = (imgSrc) => {
      if (selectedOptionImg && imgSrc) {
        selectedOptionImg.setAttribute("src", imgSrc);
      }

      if (
        selectedOptionImg &&
        selectedOptionImg.getAttribute("data-option") === "Pocket Style" &&
        imgSrc
      ) {
        const pocketOptionImage = document.getElementById("pocket-image-preview");
        if (pocketOptionImage) {
          pocketOptionImage.setAttribute("src", imgSrc);
        }
      }
    };

    const updateActiveChoice = (value) => {
      this.querySelectorAll(".flyout-choice").forEach((choice) => {
        choice.classList.remove("active");

        if (choice.getAttribute("data-value") === value) {
          choice.classList.add("active");

          const imgElement = choice.querySelector("img");
          if (imgElement) {
            const imgSrc = imgElement.getAttribute("large-src");
            updateImage(imgSrc);
          } else {
            console.warn("No img element found in", choice);
          }
        }
      });
    };

    if (optionSelect) {
      const selectedValue = optionSelect.value;
      updateActiveChoice(selectedValue);

      optionSelect.addEventListener("change", (e) => {
        updateActiveChoice(e.target.value);
      });
    }

    if (imageSwatchContainer) {
      imageSwatchContainer.addEventListener("click", (e) => {
        const optionChoice = e.target.closest(".flyout-choice");
        if (!optionChoice) return;

        const newOptionChoice = optionChoice.getAttribute("data-value");
        updateActiveChoice(newOptionChoice);

        if (optionSelect) {
          optionSelect.value = newOptionChoice;
          optionSelect.dispatchEvent(new Event("input", { bubbles: true }));
        }
      });
    }
  }
}

customElements.define("flyout-option", FlyoutOption);